import { useEffect } from 'react';

import { PWA_SERVICE_WORKER_PATH } from '@/lib/pwa';

/**
 * Production-only worker registration. Dev unregisters leftover workers so
 * Vite HMR and SSR are not intercepted.
 */
export function RegisterServiceWorker() {
    useEffect(() => {
        if (!('serviceWorker' in navigator)) return;

        if (import.meta.env.DEV) {
            void navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (const registration of registrations) {
                    void registration.unregister();
                }
            });
            if ('caches' in window) {
                void caches.keys().then((keys) =>
                    Promise.all(
                        keys
                            .filter((key) => key.startsWith('ashkelon-news-pwa-'))
                            .map((key) => caches.delete(key)),
                    ),
                );
            }
            return;
        }

        void navigator.serviceWorker.register(PWA_SERVICE_WORKER_PATH, { scope: '/' });
    }, []);

    return null;
}
